import styled, { css } from 'styled-components';

export default styled.div.attrs({
  className: 'mobile-filters',
})`
  ${({ theme }) => {
    const { media } = theme;
    return css`
        .filter-container {
            display:flex;
            ${media.mobile.down} {
                flex-direction: column;
            }
        }

        ${media.mobile.down} {
            .label {
                border-bottom: none;
                text-align: center;
                margin-bottom: 10px;
                padding-bottom: 20px;
            }
        }

        .product-filters {
            ${media.tablet.up} {
                &__sweetener {
                    margin-left: 40px;
                }

                &__phone {
                    .label {
                        white-space: nowrap;
                        font-weight: 500;
                    }
                }
            }

            ${media.mobile.down}{
                &__phone {
                    display: flex;
                    justify-content: space-around;
                    .label {
                        white-space: nowrap;
                        font-size: 12px;
                    }
                }
            }
        }

        .add-ons-title {
            font-weight: 700;
            text-align: center;
            padding: 16px 0 16px;
        }

        .add-ons {
            background-color: #F3F4F4;
        }
        
        .tooltip {
            padding-top: 8px;
        }
    `;
  }};
`;